import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';
import type { DataProvider } from './types';

const DataProviderContext = createContext<DataProvider | null>(null);

interface DataProviderWrapperProps {
  children: ReactNode;
  provider: DataProvider;
}

export function DataProviderWrapper({ children, provider }: DataProviderWrapperProps) {
  return (
    <DataProviderContext.Provider value={provider}>
      {children}
    </DataProviderContext.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export function useDataProvider(): DataProvider {
  const context = useContext(DataProviderContext);
  if (!context) {
    throw new Error('useDataProvider must be used within a DataProviderWrapper');
  }
  return context;
}